var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column h-100 w-100 pa-6"},[_c('div',{staticClass:"flex-grow-1"},[_vm._t("default")],2),_c('login-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }